/* eslint-disable import/no-cycle */
/* eslint-disable react/no-array-index-key */
/* eslint-disable react/no-unused-prop-types */
/* eslint-disable react/require-default-props */

import React from 'react';
import isEqual from 'lodash/isEqual';
import { useStoreState } from '../../../../../models/hooks';
import { useGetItemProperty } from '../../hooks/useGetItemProperty';
import TextInput from '../../formInputs/TextInput';
import { useUpdateFormItem } from '../../hooks/useUpdateFormItem';
import withToggleVisibility from '../../utils/withToggleVisibility';
import { ValidationTypeEnum } from '../../hooks/useHireFormErrorHandling';
import { TextPreviewElement } from '../../formInputs/FormTextInput';
import { FieldDocumentReviewT, TextWithTranslationsT } from '../../types';

interface DocumentTextInputProps {
  value: string;
  fieldId: string;
  // path: (string | number)[];
  placeholder?: string;
  onBlur?: () => void;
  isAdvanced?: boolean;
}
function DescriptionComponent({ fieldId, onBlur, isAdvanced }: DocumentTextInputProps) {
  const language = useStoreState((state) => state.formBuilder.currentLanguage);
  const defaultLanguage = useStoreState((state) => state.formBuilder.defaultLanguage);
  const languages = useStoreState((state) => state.formBuilder.availableLanguages);
  const handleOnChange = useUpdateFormItem();
  const value = useGetItemProperty<FieldDocumentReviewT['description'] | null | undefined>(fieldId, 'documentReview.description');

  const handleDescriptionChange = React.useCallback(
    (newDescription: string) => {
      const description = { ...value, [language]: newDescription };

      handleOnChange(fieldId, { documentReview: { description } });
      onBlur?.();
    },
    /* eslint-disable-next-line react-hooks/exhaustive-deps */
    [language, defaultLanguage, languages, handleOnChange],
  );
  return (
    <TextInput
      fieldId={fieldId}
      property="documentReview"
      innerPath={`description.${language}`}
      language={language}
      label={value?.[language] || ''}
      onLabelChange={handleDescriptionChange}
      placeholder="Enter description here...."
      isAdvanced={isAdvanced || false}
    />
  );
}

const FormTextInputComponentWrapper = withToggleVisibility(DescriptionComponent);
const DocumentDescriptionTextInput = React.memo(
  ({ fieldId, isAdvanced }: { fieldId: string; isAdvanced: boolean }) => {
    // const currentPath = React.useMemo(() => [...path, 'documentReview', 'description'], [path]);
    const language = useStoreState((state) => state.formBuilder.currentLanguage);
    const currentValue =
      useGetItemProperty<TextWithTranslationsT | null | undefined>(fieldId, 'documentReview.description') || {};

    // const fullPathToData = React.useMemo(() => {
    //   return [...currentPath, 'text', language];
    // }, [currentPath, language]);

    return (
      <FormTextInputComponentWrapper
        initialValue={currentValue}
        validate={(callback, value) => {
          callback(value);
        }}
        validationType={ValidationTypeEnum.TEXT}
        currentLanguage={language}
        // path={fullPathToData}
        fieldId={fieldId}
        innerPath={`documentReview.description.${language}`}
        placeholder="Enter description here...."
        previewComponent={(value, error, placeholder) => (
          <TextPreviewElement value={value} error={error} placeholderText={placeholder} />
        )}
        isAdvanced={isAdvanced}
      />
    );
  },
  (p, n) => isEqual(p.fieldId, n.fieldId),
);

DocumentDescriptionTextInput.displayName = 'DocumentDescriptionTextInput';

export default DocumentDescriptionTextInput;
